import * as React from 'react';
import * as mui from '@mui/material/';
import * as icons from '@mui/icons-material';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import ProductThumbnail from '../ProductThumbnail';
import { InventoryItem } from 'models/CartItem';
import { usePreviewPageContext } from 'context/PreviewPageContext';

const tree: TreeItemsGroup[] = [
	{
		id: 'story1',
		title: 'Radici di futuro',
		subtitle: '',
	},
	{
		id: 'story2',
		title: 'Le parole inventano mondi',
		subtitle: '',
	},
	{
		id: 'story3',
		title: 'Scoprire è crescere',
		subtitle: '',
	},
	{
		id: 'story4',
		title: 'Crea il tuo mondo',
		subtitle: '',
	},
	{
		id: 'audiobookX',
		title: 'Audiolibro personalizzato',
		subtitle:
			'Faboola ti propone oggi il <b>primo audiolibro personalizzato per chi ami! E verrà letta a voce anche la dedica che hai indicato per il libro!</b> Accederai a un file audio in formato <b>.mp3</b> del libro scelto e potrai riprodurlo quando vuoi su qualsiasi dispositivo, dagli smartphone agli assistenti Google o Alexa, in auto o a casa, anche come storia della buonanotte!',
		imageSrc: 'https://faboo.la/wp-content/uploads/2023/12/prodotto_audiolibro-faboola_R.jpg',
		subItems: [
			{ id: 'audiobook1', title: 'Audiolibro "Radici di futuro" di @NAME2, @NAME1 e @NAME3' },
			{ id: 'audiobook2', title: 'Audiolibro "Le parole inventano mondi" di @NAME2, @NAME1 e @NAME3' },
			{ id: 'audiobook3', title: 'Audiolibro "Scoprire è crescere" di @NAME3, @NAME1 & @NAME2' },
			{ id: 'audiobook4', title: 'Audiolibro "Crea il tuo mondo" di @NAME3, @NAME1 & @NAME2' },
		],
	},
	{
		id: 'static1',
		title: 'Libri dei Giochi & Lavoretti',
		subtitle: 'Allena la creatività dei tuoi bambini e di tutta la famiglia con una selezione dei migliori giochi e lavoretti di Faboola!',
		imageSrc: 'https://faboo.la/wp-content/uploads/2023/03/IMM1.jpg',
		subItems: [
			// { id: 'static_craftbook_autumn', title: 'Giochi & Lavoretti Autunno' },
			{ id: 'static_craftbook_winter', title: 'Giochi & Lavoretti Inverno' },
			// { id: 'static_craftbook_spring', title: 'Giochi & Lavoretti Primavera' },
			{ id: 'static_christmas1', title: '17 esercizi di felicità per questo Natale' },
		],
	},
	// Per riattivare il calendario dell'avvento, togliere i commenti:
	// {
	// 	id: 'calendar1',
	// 	title: "Il favoloso Calendario dell'Avvento",
	// 	subtitle:
	// 		'Un’edizione limitata per un Natale speciale! E dopo potrai staccare il foglio con le finestrelle e diventerà un bellissimo poster! <i>In robusto cartoncino martellato Fedrigoni Tintoretto, formato A4.</i>',
	// 	imageSrc: 'https://faboo.la/wp-content/uploads/2021/11/Faboola_Calendario_A.jpg',
	// 	subItems: [
	// 		{ id: 'calendar1_A', title: "Il favoloso Calendario dell'Avvento di @NAME1" },
	// 		{ id: 'calendar1_B', title: "Il favoloso Calendario dell'Avvento di @NAME2" },
	// 		{ id: 'calendar1_C', title: "Il favoloso Calendario dell'Avvento di @NAME3" },
	// 	],
	// },
	{
		id: 'notebook1',
		title: 'Quaderno personalizzato in formato A5',
		subtitle: `In 64 resistenti pagine uso mano protette da una robusta copertina in cartoncino martellato Fedrigoni Tintoretto, l'esclusivo quaderno Faboola permetterà a @NAME1, @NAME2 o @NAME3 di scatenare la propria creatività dando vita a faboolosi viaggi! <i>Misura 14,8x21 cm. (chiuso), 29,7x21 cm. (aperto)</i>`,
		imageSrc: 'https://faboo.la/wp-content/uploads/2021/11/Faboola-Quaderno-A5_A.jpg',
		subItems: [
			{ id: 'notebook1_A', title: 'Il Quaderno di @NAME1' },
			{ id: 'notebook1_B', title: 'Il Quaderno di @NAME2' },
			{ id: 'notebook1_C', title: 'Il Quaderno di @NAME3' },
		],
	},
	{
		id: 'posterX_A2',
		title: 'Megaposter personalizzato in formato A2',
		subtitle: `Rappresenta in grande il legame tra @NAME1, @NAME2 e @NAME3. Ecco il megaposter da appendere in cameretta! <i>Misura 42x60 cm.</i>`,
		imageSrc: 'https://faboo.la/wp-content/uploads/2021/11/Faboola-PosterA2_A.jpg',
		subItems: [
			{ id: 'poster1_A2', title: 'Il megaposter "Radici di futuro" di @NAME2, @NAME1 e @NAME3' },
			{ id: 'poster2_A2', title: 'Il megaposter "Le parole inventano mondi" di @NAME2, @NAME1 e @NAME3' },
			{ id: 'poster3_A2', title: 'Il megaposter "Scoprire è crescere" di @NAME3, @NAME1 & @NAME2' },
			{ id: 'poster4_A2', title: 'Il megaposter "Crea il tuo mondo" di @NAME3, @NAME1 & @NAME2' },
		],
	},
	{
		id: 'posterX_A4',
		title: 'Poster personalizzato in formato A4',
		subtitle: `È perlescente: in base all'incidenza della luce brillerà come un luminoso segno d'amicizia, affetto o amore tra @NAME1, @NAME2 e @NAME3! Misura 29,7x21 cm.`,
		imageSrc: 'https://faboo.la/wp-content/uploads/2021/11/Faboola-PosterA4_A.jpg',
		subItems: [
			{ id: 'poster1_A4', title: 'Il poster "Radici di futuro" di @NAME2, @NAME1 e @NAME3' },
			{ id: 'poster2_A4', title: 'Il poster "Le parole inventano mondi" di @NAME2, @NAME1 e @NAME3' },
			{ id: 'poster3_A4', title: 'Il poster "Scoprire è crescere" di @NAME3, @NAME1 & @NAME2' },
			{ id: 'poster4_A4', title: 'Il poster "Crea il tuo mondo" di @NAME3, @NAME1 & @NAME2' },
		],
	},
];

const defaultStatus: Record<TreePrimaryItemID, boolean> = {
	story1: true,
	story2: true,
	story3: true,
	story4: true,
	audiobookX: false,
	posterX_A2: false,
	posterX_A4: false,
	notebook1: false,
	calendar1: false,
	static1: false,
};

export default function ProductsAccordions() {
	const {
		selectedStory,
		handleBack,
		inventoryItems,
		bookVariables,
		name1,
		name2,
		name3,
		character1,
		character2,
		character3,
		dedication1,
		dedication2,
		dedication3,
		dedication4,
		setDedication1,
		setDedication2,
		setDedication3,
		setDedication4,
		productsChecked: checked,
		setProductsChecked: setChecked,
		handleContinue,
	} = usePreviewPageContext();

	const [collapsed, setCollapsed] = React.useState<Record<TreePrimaryItemID, boolean>>(defaultStatus);
	const smUp = mui.useMediaQuery((theme: mui.Theme) => theme.breakpoints.up('sm'));

	const withVariables = (input: string, mode: 'NAME1_IS_FIRST_SELECTED_CHARACTER' | 'NAME1_IS_MAIN_CHARACTER') => {
		const [newName1, newName2, newName3] =
			mode === 'NAME1_IS_MAIN_CHARACTER'
				? [character1, character2, character3].map(character => [name1, name2, name3][Number(character.charAt(0)) - 1])
				: [bookVariables.name1, bookVariables.name2, bookVariables.name3];

		return input
			.replace(new RegExp('@NAME1', 'g'), newName1)
			.replace(new RegExp('@NAME2', 'g'), newName2)
			.replace(new RegExp('@NAME3', 'g'), newName3);
	};

	const getInventoryItem = (name: string) => {
		const rawItem = inventoryItems.find(item => item.name === name)!;
		rawItem.titles = rawItem.titles.map(title =>
			withVariables(title, rawItem.name === 'notebook1' ? 'NAME1_IS_FIRST_SELECTED_CHARACTER' : 'NAME1_IS_MAIN_CHARACTER'),
		);

		return rawItem;
	};

	const getTreeWithVariables = (tree: TreeItemsGroup[]) => {
		const withVars = tree.map(item => {
			const withVariablesMode = item.id === 'notebook1' ? 'NAME1_IS_FIRST_SELECTED_CHARACTER' : 'NAME1_IS_MAIN_CHARACTER';

			return {
				...item,
				title: withVariables(item.title, withVariablesMode),
				subtitle: withVariables(item.subtitle, withVariablesMode),
				subItems: item.subItems
					? item.subItems.map(subItem => ({ ...subItem, title: withVariables(subItem.title, withVariablesMode) }))
					: undefined,
			};
		});
		// Move the selected story to the top
		const selectedStoryIndex = withVars.findIndex(item => item.id === selectedStory);
		withVars.unshift(withVars.splice(selectedStoryIndex, 1)[0]);
		return withVars;
	};

	const handleGroupClick = (id: TreePrimaryItemID) => () => {
		setCollapsed(collapsed => ({ ...collapsed, [id]: !collapsed[id] }));
	};

	const handleToggle = (id: TreePrimaryItemID | TreeSecondaryItemID) => () => {
		const currentIndex = checked.indexOf(id);
		let newChecked = [...checked];

		if (currentIndex === -1) {
			newChecked.push(id);
		} else {
			newChecked = newChecked.filter(e => e !== id);
		}

		setChecked(newChecked);
	};

	const handleDedication1Change = (event: React.ChangeEvent<HTMLInputElement>) => {
		setDedication1(event.target.value.slice(0, 160));
	};

	const handleDedication2Change = (event: React.ChangeEvent<HTMLInputElement>) => {
		setDedication2(event.target.value.slice(0, 160));
	};

	const handleDedication3Change = (event: React.ChangeEvent<HTMLInputElement>) => {
		setDedication3(event.target.value.slice(0, 160));
	};

	const handleDedication4Change = (event: React.ChangeEvent<HTMLInputElement>) => {
		setDedication4(event.target.value.slice(0, 160));
	};

	const PriceCheckbox = ({
		treePrimaryItemId,
		treeSecondaryItemId,
		inventoryItem,
		checked,
		...BoxProps
	}: {
		treePrimaryItemId: TreePrimaryItemID;
		treeSecondaryItemId?: TreeSecondaryItemID;
		inventoryItem: InventoryItem;
		checked: boolean;
	} & mui.BoxProps) => {
		return (
			<mui.Box {...BoxProps} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', ...BoxProps?.sx }}>
				<Checkbox
					color='secondary'
					onChange={handleToggle(treeSecondaryItemId ?? treePrimaryItemId)}
					checked={checked}
					disabled={treePrimaryItemId === selectedStory}
				/>

				{inventoryItem.discountedPrice && inventoryItem.discountedPrice < inventoryItem.price && (
					<mui.Typography
						variant='body2'
						color={checked ? 'secondary' : 'textPrimary'}
						sx={{ textDecoration: 'line-through', textAlign: 'center' }}
					>
						{new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(inventoryItem.price)}
					</mui.Typography>
				)}

				<mui.Typography variant='body2' align='center' color={checked ? 'secondary' : 'textPrimary'}>
					{new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(
						inventoryItem.discountedPrice ?? inventoryItem.price,
					)}
				</mui.Typography>
			</mui.Box>
		);
	};

	const BuyButtons = (props: mui.BoxProps) => (
		<mui.Box sx={{ display: 'flex', width: '100%', justifyContent: 'flex-end', alignItems: 'center', ...props.sx }}>
			<mui.Button onClick={handleBack} sx={{ mr: 1 }}>
				Indietro
			</mui.Button>

			<mui.Button variant='contained' onClick={handleContinue} endIcon={<icons.ShoppingCartOutlined />}>
				Vai al carrello
			</mui.Button>
		</mui.Box>
	);

	return (
		<>
			<List sx={{ width: '100%', maxWidth: 650 }}>
				{getTreeWithVariables(tree).map(({ id, title, subtitle, imageSrc, subItems }, index) => {
					if (subItems) {
						const open = collapsed[id];

						return (
							<>
								<mui.ListItemButton onClick={handleGroupClick(id)}>
									{imageSrc && <mui.Box component='img' src={imageSrc} alt={id} width={130} sx={{ boxShadow: 5 }} />}
									<mui.ListItemText
										primary={
											<mui.Box component='span' color='#fff' fontWeight='bold' dangerouslySetInnerHTML={{ __html: title }} />
										}
										secondary={smUp && <mui.Box component='span' color='#fff' dangerouslySetInnerHTML={{ __html: subtitle }} />}
										sx={{ mx: 2 }}
									/>
									{open ? (
										<icons.ExpandLess sx={{ color: '#fff', fontSize: 30 }} />
									) : (
										<icons.ExpandMore sx={{ color: '#fff', fontSize: 30 }} />
									)}
								</mui.ListItemButton>

								<mui.Collapse in={open} timeout='auto' unmountOnExit>
									<mui.List component='div' disablePadding>
										{!smUp && (
											<ListItem>
												<mui.Typography variant='body2'>
													<span dangerouslySetInnerHTML={{ __html: subtitle }} />
												</mui.Typography>
											</ListItem>
										)}

										{subItems.map((subItem, index) => {
											const productName = (() => {
												if (subItem.id.includes('calendar1')) {
													return 'calendar1';
												}

												if (subItem.id.includes('notebook1')) {
													return 'notebook1';
												}

												return subItem.id;
											})();

											const inventoryItem = getInventoryItem(productName);

											return (
												<ListItem key={subItem.id} sx={{ pl: { xs: 3, sm: 5 } }}>
													<mui.Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
														<PriceCheckbox
															treePrimaryItemId={id}
															treeSecondaryItemId={subItem.id}
															inventoryItem={inventoryItem}
															checked={checked.indexOf(subItem.id) !== -1}
															sx={{ mr: 2 }}
														/>
														<ProductThumbnail
															bookVariables={bookVariables}
															productName={productName}
															meta={
																['calendar1', 'notebook1'].includes(productName)
																	? {
																			uniqueName: [
																				bookVariables.name1,
																				bookVariables.name2,
																				bookVariables.name3,
																			][index],
																			uniqueCharacter: [
																				bookVariables.character1,
																				bookVariables.character2,
																				bookVariables.character3,
																			][index],
																	  }
																	: undefined
															}
														/>
														<ListItemText
															primary={
																<mui.Box
																	component='span'
																	color='#fff'
																	dangerouslySetInnerHTML={{ __html: subItem.title }}
																	sx={{ typography: { xs: 'body2', sm: 'body1' } }}
																/>
															}
															secondary={
																<>
																	{productName.startsWith('static_') && inventoryItem.titles[1]}
																	{productName.startsWith('audiobook') && (
																		<>
																			{inventoryItem.titles[0]}!{' '}
																			<em>Se vuoi, ascolta questa demo con nomi e luoghi d'esempio:</em>
																			<mui.Box
																				component='audio'
																				controls
																				sx={{ display: 'block!important', mt: 1 }}
																			>
																				<source
																					src='https://faboo.la/faboola-demo-audiolibro.mp3'
																					type='audio/mpeg'
																				/>
																			</mui.Box>
																		</>
																	)}
																</>
															}
															sx={{ ml: 2, '&, & > *': { color: '#fff' } }}
														/>
													</mui.Box>
												</ListItem>
											);
										})}
									</mui.List>
								</mui.Collapse>

								{id === 'posterX_A4' && <BuyButtons sx={{ my: 3 }} />}
							</>
						);
					}

					const inventoryItem = getInventoryItem(id);
					const isItemChecked = checked.indexOf(id) !== -1;

					return (
						<>
							{index === 1 && (
								<>
									<BuyButtons sx={{ mb: 3 }} />
									<mui.Typography variant='h6' color='secondary' sx={{ mb: 3 }}>
										VUOI AGGIUNGERE ALTRI LIBRI DELLA COLLANA?
									</mui.Typography>
								</>
							)}
							<ListItem key={id} sx={{ mb: 3 }}>
								<mui.Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', mr: 3 }}>
									<mui.Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
										<mui.Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
											<PriceCheckbox
												treePrimaryItemId={id}
												inventoryItem={inventoryItem}
												checked={isItemChecked}
												sx={{ mr: 2 }}
											/>
											<ProductThumbnail bookVariables={bookVariables} productName={id} />
											<ListItemText
												primary={
													<mui.Box
														component='span'
														color='#fff'
														dangerouslySetInnerHTML={{ __html: inventoryItem.titles[0] }}
														fontWeight='bold'
													/>
												}
												secondary={
													smUp && (
														<mui.Box
															component='span'
															color='#fff'
															dangerouslySetInnerHTML={{ __html: inventoryItem.titles[1] }}
														/>
													)
												}
												sx={{ ml: 2 }}
											/>
										</mui.Box>

										<mui.Typography variant='body2' sx={{ display: { xs: 'block', sm: 'none' }, mt: 1 }}>
											<mui.Box component='span' color='#fff' dangerouslySetInnerHTML={{ __html: inventoryItem.titles[1] }} />
										</mui.Typography>

										{inventoryItem.name.startsWith('story') && (
											<mui.TextField
												label='Dedica'
												variant='filled'
												color='primary'
												multiline
												rows={3}
												value={
													{ story1: dedication1, story2: dedication2, story3: dedication3, story4: dedication4 }[
														inventoryItem.name as 'story1' | 'story2' | 'story3' | 'story4'
													]
												}
												onChange={
													{
														story1: handleDedication1Change,
														story2: handleDedication2Change,
														story3: handleDedication3Change,
														story4: handleDedication4Change,
													}[inventoryItem.name as 'story1' | 'story2' | 'story3' | 'story4']
												}
												InputProps={{ disableUnderline: true }}
												sx={{ mt: 2 }}
											/>
										)}
									</mui.Box>
								</mui.Box>
							</ListItem>

							{index === 3 && (
								<>
									<BuyButtons sx={{ mb: 3 }} />
									<mui.Typography variant='h6' color='secondary' sx={{ mb: 3 }}>
										ALTRO DA AGGIUNGERE?
									</mui.Typography>
								</>
							)}
						</>
					);
				})}
			</List>
		</>
	);
}
